import {AfterViewInit, Component, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {GlobalQuestionService} from '../../services/global-question.service';
import {slideInRightOnEnterAnimation, slideOutLeftOnLeaveAnimation} from 'angular-animations';
import { UserStore } from 'src/app/modules/authentication/state/user.store';
import { PolicyQuery } from 'src/app/modules/policy/state/policy.query';
import { Alert } from '../../utilities';
import { QuestionFlowSessionStore } from '../../questions/state/question-flow-session.store';
import { PolicyService } from 'src/app/modules/policy/services/policy.service';
import { RouterLinks } from '../../constants';


declare var noUiSlider: any;
declare var wNumb: any;
declare var $: any;
@Component({
    selector: 'app-edit-profile',
    templateUrl: './edit-profile.component.html',
    styleUrls: ['./edit-profile.component.scss'],
    animations: [
        slideInRightOnEnterAnimation({ duration: 600 }),
        slideOutLeftOnLeaveAnimation()
    ],
    standalone: false
})
export class EditProfileComponent implements OnInit, AfterViewInit, OnChanges {

  flow: any;
  button: any;
  person: any;
  policy: any;
  mode = '';
  showIntro = true;
  question= {
    question_copy:'Hello'
  };
  isProfile = true;
  profile: any;
  questions: any;
  first_name = '';
  last_name = '';
  person_tel = '';
  person_email = '';
  passport = '';
  id_no = '';
  address = '';
  dob = '';
  username = '';
  header = '';
  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private userStore: UserStore,
    public policyQuery: PolicyQuery,
    private questionFlowSessionStore: QuestionFlowSessionStore,
    private policyService: PolicyService,
    public questionService: GlobalQuestionService
  ) {
    this.mode = localStorage.getItem('mode');
    this.questionService?.spinner(true);
    this.route.queryParams.subscribe(params => {
      this.isProfile = (params?.isProfile === 'true');
      this.person = this.userStore.getValue();
      this.policy = this.policyQuery.getActive();
      if (this.isProfile){
        this.getProfileData();
      }
      else{
        if (this.policy?.policy_version_rel_type_id === 2){ //in renewal stage
          this.policyService.editPolicy(this.policy?.policy_id, this.policy?.session_id)
          .subscribe((p: any) => {
            console.log(p);
            this.questionService.spinner(false);
            if (p?.length) {
              this.policy = JSON.parse(JSON.stringify(p[0]));
              this.policy.person = JSON.parse(this.policy?.person);
              try { this.policy.person[0].policy_inception_date = JSON.parse(this.policy?.person[0]?.policy_inception_date)[0] || {}; } catch { }
              this.getPolicyHolderData();
            }
            else{
              this.questionService.spinner(false);
              $('#error-modal').modal('show');
              this,router.navigate([RouterLinks.PolicyHolders])
            }
            
          }, error => {
            console.log(error.error.Message);
            this.questionService.spinner(false);
              $('#error-modal').modal('show');
              this,router.navigate([RouterLinks.PolicyHolders])
          })
        }
        else
        {
          const parameters = new Map<string, string>();
          parameters.set('policy_id', this.policy.policy_id);
          parameters.set('curr_session_id', this.policy.session_id);
          //parameters.set('select', '0');
          parameters.set('rollback_v2', '1');
          this.questionService.runCommandNew(`editPolicy`, parameters).subscribe(p => {
            console.log(p);
            this.questionService.spinner(false);
            if (p?.length) {
              this.policy = JSON.parse(JSON.stringify(p[0]));
              this.policy.person = JSON.parse(this.policy?.person);
              try { this.policy.person[0].policy_inception_date = JSON.parse(this.policy?.person[0]?.policy_inception_date)[0] || {}; } catch { }
              this.getPolicyHolderData();
            }
            else{
              this.questionService.spinner(false);
              $('#error-modal').modal('show');
              this,router.navigate([RouterLinks.PolicyHolders])
            }
          }, error => {
              this.questionService.spinner(false);
              $('#error-modal').modal('show');
              this,router.navigate([RouterLinks.PolicyHolders])
          });
        }
        
      }
    })
  }

  ngOnInit(): void {
   
  }

  getProfileData(): void {
    let parameters = new Map<string, string>();
    parameters.set('person_id', this.policy?.person_id);
    this.questionService.runCommandNew(`getProfileData`, parameters, true)
      .subscribe((profile: any) => {
        this.header = profile[0][0];
        this.profile = profile[1][0];
        this.first_name = this.profile?.first_name;
        this.last_name = this.profile?.last_name;
        this.person_email = this.profile?.person_email;
        this.person_tel = this.profile?.person_tel;
        this.id_no = this.profile?.id_no;
        this.passport = this.profile?.passport;
        this.address = this.profile?.address;
        this.dob = this.profile?.dob;
        this.username = this.profile?.username;
        this.questionService?.spinner(false);
       
      })
  }
  getPolicyHolderData(): void {
    let parameters = new Map<string, string>();
    parameters.set('policy_id', this.policy?.policy_id);
    this.questionService.runCommandNew(`getPolicyHolderData`, parameters, true)
      .subscribe((questions: any) => {
        this.header = questions[0][0];
        this.questions =JSON.parse(questions[1][0].questions);
        this.first_name = this.questions.find( q => q.question_prompt === 'Name').answer;
        this.last_name = this.questions.find( q => q.question_prompt === 'Surname').answer;
        this.questionService?.spinner(false);
        this.questionFlowSessionStore.update({
          flow_id: this.questions[0].flow_id,
          superflow_id: 0
        });
       
      })
  }
  ngOnChanges(changes: SimpleChanges): void {

  }
  ngAfterViewInit(): void {
    
  }
  initCustomSelect(): void {
    $('.ui-selectmenu').selectmenu({
      change: (event: any, data: { item: { value: string; element: { attributes: { nodeValue: number; }[]; }[]; }; }) => {
        console.log(data)
        if (data?.item?.value) {
          
          
        }
      }
    });
  }
  moveOn(): void {
    this.router.navigateByUrl(this.button?.url);
  }
  showProfile(): void {
    this.showIntro = false;
    setTimeout(() => {
      this.initCustomSelect();
    }, 1000);
    
  }
  updateProfile(): void {
    console.log(this.first_name,this.last_name,this.person_email,this.person_tel)
    if (this.isProfile) {
      if (this.first_name === ''
        || this.last_name === ''
        || this.person_email === ''
        || this.person_tel === ''
      ) {
        Alert('All fields are required.')
        return;
      }
      let parameters = new Map<string, string>();
      parameters.set('person_id', this.policy?.person_id);
      parameters.set('first_name', this.first_name);
      parameters.set('last_name', this.last_name);
      parameters.set('person_email', this.person_email);
      parameters.set('person_tel', this.person_tel);
      parameters.set('user_updated', this.person?.person_id);
      this.questionService.runCommandNew(`updateProfileData`, parameters, false)
        .subscribe((result: any) => {
          Alert('Profile updated successfully.');
        })
    }
    else {
      let parameters = new Map<string, string>();
      parameters.set('policy_id', this.policy?.policy_id);
      this.questionService.runCommandNew(`notifyPolicyHolderData`, parameters, false)
        .subscribe((result: any) => {
          this.getPolicyHolderData();
          Alert('Policy holder updated successfully.');
        })
      
      
    }

  }
  onChange(event:any): void {
    console.log(event)
    switch (event?.question_prompt) {
      case 'First Name':
        this.first_name = event?.answer;
        break;
      case 'Last Name':
        this.last_name = event?.answer;
        break;
      case 'Email':
        this.person_email = event?.answer;
        break;
      case 'Mobile':
        this.person_tel = event?.answer;
        break;
    }

    
  }
  questionAnswered(event:any): void {
    this.questionService?.spinner(true);
    this.questionService.saveAnswerOnly(event).subscribe( result => this.questionService?.spinner(false));
  }

}
